import * as React from 'react'
import { reduxForm, InjectedFormProps } from 'redux-form'
import { FormGroup, Button } from 'react-bootstrap'

import { FORM_SET_PASSWORD } from '../../constants/Form'
import {
  SET_PASSWORD_FORM_PASSWORD,
  SET_PASSWORD_FORM_PASSWORD_CONFIRM
} from '../../constants/SetPasswordFormFieldName'
import { InputControlField } from '../../components/form/InputControl'
import { isRequired } from '../../utils/validators'

export interface ForgotPasswordFormData {
  password: string
  passwordConfirm: string
}

const isSame = (value, { password }) =>
  value && value !== password ? 'Hesla nejsou stejná' : undefined

export type ForgotPasswordFormProps = InjectedFormProps<ForgotPasswordFormData>

const ForgotPasswordForm: React.SFC<ForgotPasswordFormProps> = ({
  handleSubmit
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <InputControlField
        label="Heslo"
        name={SET_PASSWORD_FORM_PASSWORD}
        type="password"
        placeholder="Heslo"
        validate={[isRequired]}
      />
      <InputControlField
        label="Heslo potvrzení"
        name={SET_PASSWORD_FORM_PASSWORD_CONFIRM}
        type="password"
        placeholder="Heslo potvrzení"
        validate={[isRequired, isSame]}
      />
      <FormGroup>
        <Button bsStyle="primary" type="submit">
          Uložit
        </Button>
      </FormGroup>
    </form>
  )
}

export default reduxForm<ForgotPasswordFormData>({
  form: FORM_SET_PASSWORD
})(ForgotPasswordForm)



// WEBPACK FOOTER //
// ./src/screens/setPassword/SetPasswordForm.tsx